import React from 'react';
import { Box, Text, Link, Flex } from '@chakra-ui/react';

export const Footer: React.FC = () => {
  return (
    <Box as="footer" py={4} mt="auto" bg="gray.100" width="100%">
      <Flex 
        direction="column" 
        align="center" 
        justify="center"
        maxW="container.lg"
        mx="auto"
        px={4}
      >
        <Text fontSize="sm" color="gray.600" textAlign="center">
          Metagaim Admin Portal © {new Date().getFullYear()} | Created by Claude Sonnet
        </Text>        
      </Flex>
    </Box>
  );
};
